import React, { useEffect } from "react";
import { useState } from "react";
import { Button, TextField, Grid } from "@mui/material";
import * as sweetalert from "sweetalert";
import axios from "axios";
import packageJson from "../../../../package.json";
import { LeakRemoveTwoTone } from "@material-ui/icons";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const FormUpdates1 = ({
  id,
  company,
  fundnamecompany,
  fundtype,
  fundtype1,
  fundtype2,
  fundtype3,
  fundtype4,
  vocher_id,
  fundtypeadmin1,
}) => {
  const fundName = fundtype.map((element) => {
    if (element["p"].id === id) {
      return element["p"].fund_value;
    }
  });
  const fundName2 = fundtype.map((element) => {
    if (element["p"].id === id) {
      return element["p"].fund_name;
    }
  });

  const filteredFundName = fundName.filter((value) => value !== undefined);

  const fundCompany = fundtype2.map((element) => {
    if (element["p"].id === id) {
      return element["p"].fund_price_for_client;
    }
  });

  const priceGeneralDistributor = fundtype1.map((element) => {
    if (element["p"].id === id) {
      return element["p"].fund_price_for_general_distributor;
    }
  });

  const pricesSpecialDistributor = fundtype3.map((element) => {
    if (element["p"].id === id) {
      return element["p"].fund_price_for_special_distributor;
    }
  });

  const fundType = fundtype4.map((element) => {
    if (element["p"].id === id) {
      return element["p"].fund_profit;
    }
  });

  const fundtypeadmin = fundtypeadmin1.map((element) => {
    if (element["p"].id === id) {
      return element["p"].fund_price_for_admin;
    }
  });
  
  const VocherIDData = vocher_id
    .map((element) => {
      if (element && element["p"] && element["p"].id === id) {
        return element && element.p && element.p.voucher_id !== undefined
          ? element.p.voucher_id
          : null;
      }
      return null;
    })
    .filter((voucherId) => voucherId !== null);

  const vocher_id_unit = VocherIDData[0];
  const [Voucher, setVoucher] = useState([]);
  const [Voucher_id, setVoucherId] = useState([]);
  const [Voucher_value, setVoucherValue] = useState([]);
  const [Voucher_price_admin, setVoucherPriceAdmin] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [formValues, setFormValues] = useState({
    fund_value: fundName.filter((e) => e !== undefined),
    fund_price_for_client: fundCompany.filter((e) => typeof e === "number")[0], // Filter and get the first number
    fund_price_for_general_distributor: priceGeneralDistributor.filter(
      (e) => e !== undefined
    )[0], // Assuming it's a similar array as fundCompany
    fund_price_for_special_distributor: pricesSpecialDistributor.filter(
      (e) => e !== undefined
    )[0], // Assuming it's a similar array as fundCompany
    fund_price_for_admin: fundtypeadmin.filter((e) => e !== undefined),
  });
  const [value_fund, setValueFund] = useState();
  useEffect(() => {
    axios
      .get(`${BaseUrl}/api/getAllVoucherList`, {
        withCredentials: true,
      })
      .then((res) => {
        setIsLoading(true);
        setVoucher(res.data.vouchersList);
      });
  }, []);
  useEffect(() => {
    if (Voucher.length > 0) {
      if (fundnamecompany === "وحدات Syriatel") {
        const filteredVoucher =
          Voucher &&
          Voucher.find((element) => element.voucherId === vocher_id_unit);
        setVoucherValue(filteredVoucher.id);
        setValueFund(filteredVoucher.voucherAmount);
        setVoucherPriceAdmin(filteredVoucher.totalAmount);
        setVoucherId(filteredVoucher.voucherId);
        setFormValues({
          ...formValues,
          fund_value: filteredVoucher.voucherAmount,
          fund_price_for_admin: filteredVoucher.totalAmount,
          voucher_id: filteredVoucher.voucherId,
        });
        setValueFund(filteredVoucher.voucherAmount);
      }
    }
  }, [Voucher]);

  const onSubmit = (event) => {
    event.preventDefault();
    const config = {
      headers: {
        Accept: "application/json",
        Authorization: null,
        sameSite: "strict",
      },
    };

    if (fundnamecompany == "وحدات MTN") {
      function convertNumericValues(obj) {
        const convertedObj = {};

        for (const key in obj) {
          if (Array.isArray(obj[key])) {
            // Take the first element of the array and convert it to a number
            convertedObj[key] =
              obj[key].length > 0 ? Number(obj[key][0]) : null;
          } else if (typeof obj[key] === "string" && /^\d+$/.test(obj[key])) {
            // Convert string to a number
            convertedObj[key] = Number(obj[key]);
          } else {
            convertedObj[key] = obj[key];
          }
        }

        return convertedObj;
      }
      const convertedFormData = convertNumericValues(formValues);
      const data = {
        fund_value: formValues.fund_value,
        fund_price_for_client: formValues.fund_price_for_client,
        fund_price_for_general_distributor:
          formValues.fund_price_for_general_distributor,
        fund_price_for_special_distributor:
          formValues.fund_price_for_special_distributor,
        fund_price_for_admin: formValues.fund_price_for_admin,
        voucher_id: "",
      };
      axios.get(`${BaseUrl}/sanctum/csrf-cookie`, config).then((response) => {
        axios
          .post(`${BaseUrl}/api/updateValuesTofund/${id}`, convertedFormData, {
            withCredentials: true,
          })
          .then((res) => {
            if (res.data.status === true) {
              sweetalert(res.data.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              })
                .then(window.location.reload())
                .catch((error) => {
                  console.error("Error in SweetAlert Promise chain:", error);
                });
            }
          });
      });
    } else if (fundnamecompany == "Syriatel كاش") {
      function convertNumericValues(obj) {
        const convertedObj = {};

        for (const key in obj) {
          if (Array.isArray(obj[key])) {
            // Take the first element of the array and convert it to a number
            convertedObj[key] =
              obj[key].length > 0 ? Number(obj[key][0]) : null;
          } else if (typeof obj[key] === "string" && /^\d+$/.test(obj[key])) {
            // Convert string to a number
            convertedObj[key] = Number(obj[key]);
          } else {
            convertedObj[key] = obj[key];
          }
        }

        return convertedObj;
      }

      const data = {
        fund_value: formValues.fund_value,
        fund_price_for_client: formValues.fund_price_for_client,
        fund_price_for_general_distributor:
          formValues.fund_price_for_general_distributor,
        fund_price_for_special_distributor:
          formValues.fund_price_for_special_distributor,
        fund_price_for_admin: formValues.fund_price_for_admin,
        voucher_id: "",
      };
      const convertedFormData = convertNumericValues(formValues);
      axios.get(`${BaseUrl}/sanctum/csrf-cookie`, config).then((response) => {
        axios
          .post(`${BaseUrl}/api/updateValuesTofund/${id}`, convertedFormData, {
            withCredentials: true,
          })
          .then((res) => {
            if (res.data.status === true) {
              sweetalert(res.data.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              })
                .then(window.location.reload())
                .catch((error) => {
                  console.error("Error in SweetAlert Promise chain:", error);
                });
            }
          });
      });
    }
    if (fundnamecompany == "MTN كاش") {
      function convertNumericValues(obj) {
        const convertedObj = {};

        for (const key in obj) {
          if (Array.isArray(obj[key])) {
            // Take the first element of the array and convert it to a number
            convertedObj[key] =
              obj[key].length > 0 ? Number(obj[key][0]) : null;
          } else if (typeof obj[key] === "string" && /^\d+$/.test(obj[key])) {
            // Convert string to a number
            convertedObj[key] = Number(obj[key]);
          } else {
            convertedObj[key] = obj[key];
          }
        }

        return convertedObj;
      }

      const data = {
        fund_value: formValues.fund_value,
        fund_price_for_client: formValues.fund_price_for_client,
        fund_price_for_general_distributor:
          formValues.fund_price_for_general_distributor,
        fund_price_for_special_distributor:
          formValues.fund_price_for_special_distributor,
        fund_price_for_admin: formValues.fund_price_for_admin,
        voucher_id: "",
      };
      const convertedFormData = convertNumericValues(formValues);
      axios.get(`${BaseUrl}/sanctum/csrf-cookie`, config).then((response) => {
        axios
          .post(`${BaseUrl}/api/updateValuesTofund/${id}`, convertedFormData, {
            withCredentials: true,
          })
          .then((res) => {
            if (res.data.status === true) {
              sweetalert(res.data.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              })
                .then(window.location.reload())
                .catch((error) => {
                  console.error("Error in SweetAlert Promise chain:", error);
                });
            }
          });
      });
    } else if (
      fundnamecompany == "وحدات Syriatel" ||
      fundnamecompany != "MTN كاش" ||
      fundnamecompany != "Syriatel كاش"
    ) {
      const data = {
        fund_value: Voucher_value,
        fund_price_for_client: formValues.fund_price_for_client,
        fund_price_for_general_distributor:
          formValues.fund_price_for_general_distributor,
        fund_price_for_special_distributor:
          formValues.fund_price_for_special_distributor,
        fund_price_for_admin: Voucher_price_admin,
        voucher_id: Voucher_id,
      };
      axios.get(`${BaseUrl}/sanctum/csrf-cookie`, config).then((response) => {
        axios
          .post(`${BaseUrl}/api/updateValuesTofund/${id}`, data, {
            withCredentials: true,
          })

          .then((res) => {
            if (res.data.status === true) {
              sweetalert(res.data.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              }).then(window.location.reload());
            } else if (res.data.status === false) {
              sweetalert(res.data.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              }).then(() => {
                window.location.reload();
              });
            }
          });
      });
    }
  };

  const handleChange = (e) => {
    e.persist();
    if (e.target.name === "fund_value") {
      setValueFund(e.target.value);
    }
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };
  const handelChangeValue = (e) => {
    const selectedId = parseInt(e);
    setVoucherValue(selectedId);
    setValueFund(selectedId);
    setFormValues({ ...formValues, fund_value: selectedId });
    const filteredVouchers = Voucher.filter(
      (voucher) => voucher.voucherAmount === selectedId
    );
    filteredVouchers.map((e) => {
      setVoucherPriceAdmin(e.totalAmount);

      setFormValues({ ...formValues, fund_price_for_admin: e.totalAmount });
      setFormValues({ ...formValues, voucher_id: e.voucherId });
      setVoucherId(e.voucherId);
    });
  };

  return (
    <form onSubmit={onSubmit} style={{ height: isLoading ? "" : "450px" }}>
      {fundnamecompany == "وحدات Syriatel" ? (
        isLoading ? (
          <Grid container maxWidth="sm" spacing={2}>
            <Grid item md={6} xs={12}>
              <label>قيمة الرصيد</label>
              <div class="select">
                <select
                  className="form-control"
                  class="select-text select-fund-value"
                  name="fund_value"
                  value={value_fund || formValues.fund_value}
                  onChange={(e) => handelChangeValue(e.target.value)}
                >
                  <option selected disabled>
                    اختر قيمة الرصيد
                  </option>
                  {Voucher.map((opts, i) => (
                    <option key={opts.id} value={opts.id}>
                      {opts.voucherAmount}
                    </option>
                  ))}
                </select>
                <span class="select-highlight"></span>
                <span class="select-bar"></span>
              </div>
            </Grid>
            <Grid item md={6} xs={12}>
              return (
              <TextField
                label="سعر للادمن"
  
                className="form-control"
                id="fund_price"
                disabled
                name="fund_price_for_admin"
                onChange={handleChange}
                value={Voucher_price_admin || formValues.fund_price_for_admin}
              />
              );
            </Grid>
            <Grid item md={6} xs={12}>
              return (
              <TextField
                label="سعر الزبون"
                className="form-control"
                id="fund_price"
                name="fund_price_for_client"
                onChange={handleChange}
                value={formValues.fund_price_for_client}
              />
              );
            </Grid>

            <Grid item md={6} xs={12}>
              return (
              <TextField
                label="سعر الموزع العام"
  
                className="form-control"
                id="fund_price"
                name="fund_price_for_general_distributor"
                onChange={handleChange}
                value={formValues.fund_price_for_general_distributor}
              />
              );
            </Grid>
            <Grid item md={6} xs={12}>
              return (
              <TextField
                label="سعر الموزع الخاص"
  
                className="form-control"
                id="fund_price"
                name="fund_price_for_special_distributor"
                onChange={handleChange}
                value={formValues.fund_price_for_special_distributor}
              />
              );
            </Grid>
          </Grid>
        ) : (
          <div class="spinner1 center">
            <div class="spinner-blade1"></div>
            <div class="spinner-blade1"></div>
            <div class="spinner-blade1"></div>
            <div class="spinner-blade1"></div>
            <div class="spinner-blade1"></div>
            <div class="spinner-blade1"></div>
            <div class="spinner-blade1"></div>
            <div class="spinner-blade1"></div>
            <div class="spinner-blade1"></div>
            <div class="spinner-blade1"></div>
            <div class="spinner-blade1"></div>
            <div class="spinner-blade1"></div>
          </div>
        )
      ) : fundnamecompany == "MTN كاش" || fundnamecompany == "Syriatel كاش" ? (
        <Grid container maxWidth="sm" spacing={2}>
          <Grid item md={6} xs={12}>
            return (
            <TextField
              label=" قيمة الرصيد"

              className="form-control"
              id="fund_value"
              name="fund_value"
              onChange={handleChange}
              value={formValues.fund_value}
            />
            ),
          </Grid>
          <Grid item md={6} xs={12}>
            return (
            <TextField
              label="سعر للادمن"

              className="form-control"
              id="fund_value"
              name="fund_price_for_admin"
              onChange={handleChange}
              value={formValues.fund_price_for_admin}
            />
            ),
          </Grid>
          <Grid item md={6} xs={12}>
            return (
            <TextField
              label="سعر الزبون"

              className="form-control"
              id="fund_price"
              name="fund_price_for_client"
              onChange={handleChange}
              value={formValues.fund_price_for_client}
            />
            );
          </Grid>

          <Grid item md={6} xs={12}>
            return (
            <TextField
              label="سعر الموزع العام"

              className="form-control"
              id="fund_price"
              name="fund_price_for_general_distributor"
              onChange={handleChange}
              value={formValues.fund_price_for_general_distributor}
            />
            );
          </Grid>
          <Grid item md={6} xs={12}>
            return (
            <TextField
              label="سعر الموزع الخاص"

              className="form-control"
              id="fund_price"
              name="fund_price_for_special_distributor"
              onChange={handleChange}
              value={formValues.fund_price_for_special_distributor}
            />
            );
          </Grid>
        </Grid>
      ) : (
        <Grid container maxWidth="sm" spacing={2}>
          <Grid item md={6} xs={12}>
            <TextField
              label=" قيمة الرصيد"

              className="form-control"
              id="fund_value"
              name="fund_value"
              onChange={handleChange}
              value={formValues.fund_value}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              label="سعر للادمن"

              className="form-control"
              id="fund_value"
              name="fund_price_for_admin"
              onChange={handleChange}
              value={formValues.fund_price_for_admin}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              label="سعر الزبون"

              className="form-control"
              id="fund_price"
              name="fund_price_for_client"
              onChange={handleChange}
              value={formValues.fund_price_for_client}
            />
          </Grid>

          <Grid item md={6} xs={12}>
            <TextField
              label="سعر الموزع العام"

              className="form-control"
              id="fund_price"
              name="fund_price_for_general_distributor"
              onChange={handleChange}
              value={formValues.fund_price_for_general_distributor}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              label="سعر الموزع الخاص"

              className="form-control"
              id="fund_price"
              name="fund_price_for_special_distributor"
              onChange={handleChange}
              value={formValues.fund_price_for_special_distributor}
            />
          </Grid>
        </Grid>
      )}
      {isLoading ? (
        <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
          <Button
            type="submit"
            variant="contained"
            className="btn-submit"
            color="secondary"
          >
            حفظ
          </Button>
        </Grid>
      ) : (
        <></>
      )}
    </form>
  );
};
export default FormUpdates1;
